import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { vocabularyApi } from "../services/vocabularyApi";
import { buildVocabularyIndex, type VocabularyIndex } from "../utils/vocabulary";
import type { VocabularyTerm } from "../types/vocabulary.types";

// Near-static catalog -> long staleTime. Returns the query plus a memoized index
// (always defined, empty before load) for resolveToCanonical/getEnumLabel.
export function useVocabulary() {
  const query = useQuery<VocabularyTerm[]>({
    queryKey: ["inventory", "vocabulary"],
    queryFn: () => vocabularyApi.getVocabulary(),
    staleTime: 5 * 60_000,
  });

  const index: VocabularyIndex = useMemo(
    () => buildVocabularyIndex(query.data ?? []),
    [query.data],
  );

  return { ...query, index };
}
